import { Component, Input, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SeguridadSocial } from '../../../models/seguridad-social';
import { ConfigDataService } from '../../../services/config-data.service';
import { IboxtoolsItem } from '../../../models/iboxtools-item';
import { SeguridadSocialService } from '../../../services/seguridad-social.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmacionComponent } from '../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../components/shared/dialog-procesando/dialog-procesando.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErroresService } from '../../../core/services/errores.service';
import {MyValidations} from '../../../utils/my-validations';
import { GruposLiquidacionService } from '../../../services/gruposLiquidacion.service';
import { PlanesObrasSocialesService } from '../../../services/planes-obras-sociales.service';
import { MomentSetService } from '../../../core/services/moment-set.service';

@Component({
  selector: 'app-seguridad-social',
  templateUrl: './seguridad-social.component.html',
  styleUrls: ['./seguridad-social.component.css']
})
export class SeguridadSocialComponent implements OnInit {
  
  //Datos de entrada
  @Input() legajo;
  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;
  
  seguridadSocial: any;
  form: FormGroup;
  seguridadSocialList: any;
  cortarRegistro: boolean = false;
  public cargaCompleta = false;

  constructor(private configDataSrv: ConfigDataService, 
              private dialog: MatDialog,
              private snackBar: MatSnackBar,
              private seguridadSrv: SeguridadSocialService,
              private fb: FormBuilder,
              private erroresService: ErroresService,
              private gruposLiquidacionService: GruposLiquidacionService,
              private planesService: PlanesObrasSocialesService,
              private momentService: MomentSetService) { 
    }


  MensajeError: string;
  disabledEditing: boolean = true;
  eliminando: boolean;
  eliminacionInvalida: boolean;
  datosInvalida: boolean = false;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  submitted = false;
  ingreso: any;
  obraSocialList: any;
  planObraSocialList: any;
  actividadList: any;
  agrupamientoList: any;
  caracterList: any;

  datosHistoryList: any;
  toolboxEnabled: boolean = false;
  onlyNew: boolean = true;
  
  get registerFormControl() { return this.form?.controls; }

  ngOnInit(): void
  {
    this.seguridadSocial = null;
    
    this.configDataSrv.GetSeguridadSocial()
    .subscribe(
      data => {
        this.obraSocialList=data["ObrasSociales"];
        this.planObraSocialList=data["PlanesObrasSociales"];
        this.actividadList = data["ActividadEmpleado"];
        this.agrupamientoList = data["AgrupamientoEmpleado"];
        this.caracterList = data["CaracterServicio"];
      },
      error => {
        console.log(error);
      });    

    this.configurarValidadores();
    this.obtenerActual();
    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Seguridad Social")) this.permisoEdicion = true;
  }

  configurarValidadores(): void
  {
    this.form = this.fb.group({
      id: ['', Validators.required],
      personal: ['', Validators.required],
      desde: ['', Validators.required],
      hasta: ['', [Validators.required, MyValidations.fecHastaMenor]],
      obraSocial: ['', Validators.required],
      planObraSocial: ['', Validators.required],
      nroAfiliado: ['', Validators.required],
      actividadEmpleado: ['', Validators.required],
      agrupamientoEmpleado: ['', Validators.required],
      caracterServicio: ['', Validators.required]
    });
  }

  onChangeFechas() {
    // let desde = this.form.get("desde").value;
    // let hasta = this.form.get("hasta").value;
  }

  cargarPlanes(obrasocial:number){
    if (obrasocial != null) {
      this.planesService.getByObrasocial(obrasocial).subscribe(planes => { this.planObraSocialList = planes })
    }
  }

  onChangeObrasocial(event) {
    this.form.controls['planObraSocial'].setValue(null);
    this.cargarPlanes(event.value);    
  }
  
  setearForm(datos: SeguridadSocial)
  {
    if (this.form != undefined)
    {
      this.form.controls['id'].setValue(datos?.id);
      this.form.controls['personal'].setValue(datos?.personal);
      this.form.controls['desde'].setValue(new Date(datos?.desde));
      this.form.controls['hasta'].setValue(new Date(datos?.hasta));
      this.form.controls['obraSocial'].setValue(datos?.obraSocial);
      this.form.controls['planObraSocial'].setValue(datos?.planObraSocial);
      this.form.controls['nroAfiliado'].setValue(datos?.nroAfiliado);
      this.form.controls['actividadEmpleado'].setValue(datos?.actividadEmpleado);
      this.form.controls['agrupamientoEmpleado'].setValue(datos?.agrupamientoEmpleado);
      this.form.controls['caracterServicio'].setValue(datos?.caracterServicio);

      if (datos != null && datos.id == 0)
      {
        this.habilitarForm(true);
      }
      else
      {
        this.habilitarForm(false);
      }
    }
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if (habilitado)
      {
        this.form.enable();
      }
      else
      {
        this.form.disable();
      }
    }
  }

  async OnDeleteChange(event)
  {
    if (await this.validarEdicion(this.seguridadSocial))
    {
      this.MensajeError = "";
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

          this.seguridadSrv.delete(this.seguridadSocial.id).subscribe(
            response =>
            {
              this.snackBar.open("Eliminado correctamente.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              });

              this.obtenerActual();
            },
            error =>
            {
              if (error.status == 400)
              {
              }
              else
              {
                this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
              }
              dialogProcesandoRef.close();
            });
        }
      });
    }
  }

  OnBackChange()
  {
    this.volverAtras();
  }

  async OnEditChange()
  {
    if (await this.validarEdicion(this.seguridadSocial))
    {
      this.habilitarEdicion();
      var $this = this;
      setTimeout(function ()
      {
        $this.form.controls['desde'].disable();
        $this.form.controls['hasta'].disable();
      });
    }
    
  }

  OnPeriodChange(index: number)
  {
    let dato = this.seguridadSocialList.find(d => d.id == index);
    this.seguridadSocial = dato;
    this.setearForm(this.seguridadSocial);
    this.MensajeError = "";
  }

  OnCancelChange(e: boolean)
  {
    if (this.seguridadSocialList != undefined)
    {
      if (this.seguridadSocial.id == 0 && this.seguridadSocialList.length == 0)
      {
        this.seguridadSocial = null;
      }
      else if (this.seguridadSocial.id == 0 && this.seguridadSocialList.length > 0)
      {
        this.seguridadSocial = this.seguridadSocialList[0];
      }
    }
    else
    {
      this.seguridadSocial = null;
    }

    this.setearForm(this.seguridadSocial);
    this.deshabilitarEdicion();
  }

  async OnSaveChange(e: boolean)
  {
    this.submitted = true;
    if (this.validarDatos())
    {
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let formulario = this.form.getRawValue();

      let datosSeg: SeguridadSocial = {
        id: formulario.id,
        personal: formulario.personal,
        desde: this.momentService.saveDateServer(formulario.desde, false),
        hasta: this.momentService.saveDateServer(formulario.hasta, false),
        obraSocial: formulario.obraSocial,
        planObraSocial: formulario.planObraSocial,
        nroAfiliado: formulario.nroAfiliado,
        actividadEmpleado: formulario.actividadEmpleado,
        agrupamientoEmpleado: formulario.agrupamientoEmpleado,
        caracterServicio: formulario.caracterServicio
      };

      this.seguridadSrv.save(datosSeg, this.cortarRegistro).subscribe(
        dato =>
        {
          dato.desde = this.momentService.convertDateServer(dato.desde);
          dato.hasta = this.momentService.convertDateServer(dato.hasta);

          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });

          this.snackBar.open("Seguridad Social guardada", "OK", { duration: 10000 });

          this.deshabilitarEdicion();

          this.obtenerHistorial();
          //TODO. Modificar la forma de obtener la fecha sin el TimeZone
          //dato.desde = dato.desde.replace('Z', '');
          this.setearForm(dato);
        },
        error =>
        {
          dialogProcesandoRef.close();

          if (error.status == 400)
          {
            this.datosInvalida = true;
            
            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
  }

  async OnNewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      let fdesde = new Date().toString();
      if (this.fechaslist != undefined){
        let fecha = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
        fdesde = fecha.desde
      }
      let dato: SeguridadSocial = { id: 0, personal: this.personalId, desde: fdesde, hasta: new Date("2999-12-31T23:59:59").toString(), nroAfiliado: ""};
      this.seguridadSocial = dato;
      this.setearForm(dato);

      this.habilitarEdicion();
      this.form.controls['id'].setValue(0);
      this.form.controls['hasta'].setValue(new Date("2999-12-31T23:59:59"));
    }
  }

  async OnCutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.cortarRegistro = true;
      this.habilitarEdicion();

      var $this = this;
      setTimeout(function ()
      {
        $this.form.controls['hasta'].disable();
      });
    }
  }

  add()
  {
    this.OnNewChange(true);
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarForm(false);
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarForm(true);
  }

  private volverAtras()
  {
    this.MensajeError = "";
    this.datosHistoryList = [];
    this.seguridadSocialList = [];
    this.habilitarForm(false);
  }

  private obtenerHistorial()
  {
    this.seguridadSrv.getHistoryByPersonalId(this.personalId).subscribe(
      datos =>
      {
        datos.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });

        this.datosHistoryList = [];

        if (datos.length > 0)
        {
          datos.forEach(d =>
          {
            let item = new IboxtoolsItem(d);
            this.datosHistoryList.push(item);
          });

          this.seguridadSocialList = datos;
        }
        else
        {
          this.setearForm(null);
          this.seguridadSocial = null;
          this.seguridadSocialList = [];
        }
      },
      error =>
      {
        console.log(error);
      });
  }

  private obtenerActual()
  {
    let fechaHoy = new Date();
    this.seguridadSrv.getByPersonalId(this.personalId).subscribe(
      datos =>
      {
        datos.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });
        
        if (datos.length > 0)
        {
          this.seguridadSocial = datos.find(f=> Date.parse(f.desde) <= fechaHoy.getTime() &&
                                                Date.parse(f.hasta) >= fechaHoy.getTime());
          
          if (this.seguridadSocial == null) this.seguridadSocial = datos[0];
          this.obtenerHistorial();
        }
        else
        {
          this.seguridadSocial = null;
        }
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        console.log(error);
      });
  }

  private validarDatos(): boolean
  {
    this.MensajeError = "";
    this.ingreso = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    let desde = this.form.get("desde").value.toDateString();
    let hasta = this.form.get("hasta").value.toDateString();
    
    let fingreso = new Date(this.ingreso.desde).toDateString();
    if (Date.parse(desde) < Date.parse(fingreso))
    {
      //Valida que la fecha desde no sea anterior a la fecha de ingreso
      this.form.get("desde").setErrors({'desdeAnterior': true });
    }else{
      //valida que la fecha desde no sea anterior a la fecha de retroactividad del grupo de liquidacion vigente
      if (this.gruposLiquidaciones.periodoRetroactividad != null)
      {
        let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
        if (Date.parse(desde) < Date.parse(fretro) )
        {
          this.form.get("desde").setErrors({'anteriorRetroactividad': true });
        }
      }
      
    }

    if (this.form.valid)
    {
      return true;
    }
    else
    {
      this.seguridadSocial.form.markAllAsTouched();
      return false;
    }
  }

  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private validacionRetro(desde) : boolean
  {
    let anterior = false;
    
    if (this.gruposLiquidaciones.periodoRetroactividad != null)
    {
      let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
      if (Date.parse(desde) < Date.parse(fretro) )
      {
        anterior = true;
        this.snackBar.open("Acción no válida porque es anterior al límite de retroactividad.", "OK");
      }
    }
    return anterior;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    if(edita)
    {
      let anterior = this.validacionRetro(row.desde);
      if(anterior) edita = false;  
    }
    return edita;
  }

  
}

